import React from 'react';
interface StoryTimelineProps {
  activeTime: string;
  activeIndex: number;
  onTimeSelect: (time: string, cardIndex: number) => void;
}
export function StoryTimeline({
  activeTime,
  activeIndex,
  onTimeSelect
}: StoryTimelineProps) {
  // Timeline points now match the card order (0-4 from left to right)
  const timePoints = [{
    time: '07:30',
    label: '校园防欺凌系统',
    cardIndex: 0
  }, {
    time: '09:00',
    label: '课堂质量分析系统',
    cardIndex: 1
  }, {
    time: '12:30',
    label: '身心健康数据汇聚平台',
    cardIndex: 2
  }, {
    time: '15:00',
    label: '教师精准教学服务平台',
    cardIndex: 3
  }, {
    time: '19:00',
    label: 'AI学伴',
    cardIndex: 4
  }];
  return <div className="fixed bottom-20 left-1/2 -translate-x-1/2 w-3/4 max-w-4xl z-50" data-id="element-440">
      <div className="glass-panel rounded-full px-8 py-4 flex items-center justify-between relative" data-id="element-441">
        {/* Connecting Line */}
        <div className="absolute left-12 right-12 top-1/2 h-0.5 bg-white/10 -z-10" data-id="element-442"></div>

        {timePoints.map(point => {
        // Highlight if either manually selected OR if the card is active
        const isActive = activeTime === point.time || activeIndex === point.cardIndex;
        return <button key={point.time} onClick={() => onTimeSelect(point.time, point.cardIndex)} className={`group relative flex flex-col items-center gap-2 transition-all duration-300 ${isActive ? 'scale-110' : 'hover:scale-105'}`} data-id="element-443">
              {/* Dot */}
              <div className={`w-4 h-4 rounded-full border-2 transition-all duration-300 ${isActive ? 'bg-tech-cyan border-tech-cyan shadow-[0_0_10px_#00F0FF]' : 'bg-black border-gray-500 group-hover:border-white'}`} data-id="element-444"></div>

              {/* Label */}
              <div className={`absolute top-6 flex flex-col items-center whitespace-nowrap transition-all duration-300 ${isActive ? 'opacity-100 translate-y-0' : 'opacity-60 translate-y-1 group-hover:opacity-100'}`} data-id="element-445">
                <span className={`text-sm font-mono font-bold ${isActive ? 'text-tech-cyan' : 'text-gray-300'}`} data-id="element-446">
                  {point.time}
                </span>
                <span className="text-xs text-gray-400" data-id="element-447">{point.label}</span>
              </div>
            </button>;
      })}
      </div>
    </div>;
}